export default {
  eyebrow: 'Partner portal',
  title: 'Processing fees',
  description:
    'You pay Stripe’s fees on every online payment. The processing fee set here is charged to your restaurants to cover them, unless a restaurant has a rate of its own.',
  card_title: 'Default processing fee',
  hint: 'Percentage in %, plus an optional fixed and minimum amount per payment. “Any payment method” applies when no method-specific rate exists. A change applies to payments made after it is saved.',
  hint_single:
    'The processing fee applies to every online payment method that has no rate of its own. A change applies to payments made after it is saved.',
  hidden_rates:
    'Some payment methods also have their own rate, set by your platform support. Those apply instead of this rate.',
  empty: {
    title: 'No default processing fee is set',
    description:
      'Until you set one, or confirm that you charge your restaurants no processing fee, your restaurants on Stripe can’t go live and live ones take no online payments (cash still works).',
  },
  consent: {
    give: 'We pay Stripe’s fees ourselves (confirm a 0% margin)',
    given_title: '0% margin confirmed',
    given:
      'Confirmed by {{name}} on {{date}}: restaurants without a rate of their own are charged no processing fee, and you pay Stripe’s fees on their payments.',
    unknown_manager: 'a former manager',
    withdraw: 'Withdraw',
    withdraw_confirm: {
      title: 'Withdraw the 0% margin confirmation?',
      description:
        'Restaurants without a rate of their own then can’t go live, and live ones stop taking online payments until you set a rate or confirm again.',
    },
  },
  buttons: {
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
  },
  toasts: {
    load_error: 'Could not load your processing fees.',
    failed_to_save_changes: 'Could not save your processing fees.',
    changes_got_saved: 'Processing fees saved',
    consent_given: '0% margin confirmed',
    consent_withdrawn: 'Confirmation withdrawn',
  },
};
